// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33101cfb","963":"f88bd865"}[chunkId] + ".chunk.js";
};